import { css } from "styled-components";

import { animationsCss } from "styles/utilities/animation";

export const utilistiesCss = css`
  ${animationsCss}
`;
